import CasinoEmbeddedLayout from './CasinoEmbeddedLayout';
import SportsBasicLayout from './SportsBasicLayout';
import SportsLayout from './SportsLayout';
import SportsSelfExcludedLayout from './SportsSelfExcludedLayout';
import StarsLayout from './StarsLayout';

const layouts = {
  CasinoEmbeddedLayout,
  SportsBasicLayout,
  SportsLayout,
  SportsSelfExcludedLayout,
  StarsLayout
};

export default layouts;
